import Column from '@components/column'
import Banner from '@commons/profile/documents/banner'
import Tabs from '@commons/tabs'
import Identifications from '@commons/profile/documents/identifications'
import Licenses from '@commons/profile/documents/licenses'
import Signature from '@commons/profile/documents/signature'
import CardHeading from '@commons/headings/card'
import Registrations from '@commons/profile/documents/registrations'

const InstitutionDocumentsPage = () => {
  const tabs = [
    {
      title: 'Identification',
      key: 'identification',
      Component: Identifications,
    },
    {
      title: 'Medical Documents',
      key: 'documents',
      Component: Licenses,
    },
    {
      title: 'Business Registration',
      key: 'registrations',
      Component: Registrations,
    },
    {
      title: 'Digital Signature',
      key: 'digital-signature',
      Component: Signature,
    },
  ]
  return (
    <Column rowGap={20}>
      <Banner />
      <CardHeading title="Documents" />
      <Column justifyContent="space-between">
        <Tabs items={tabs} />
      </Column>
    </Column>
  )
}

export default InstitutionDocumentsPage
